import React, {Component} from 'react';
import {Button} from 'antd';

import SystemHubCheckFirmwareModalForm from './SystemHubCheckFirmwareModalForm'

class SystemHubButtonUploadFirmware extends Component {
  state = {
    visible: false
  };
  showModal = () => {
    this.setState({visible: true});
  };
  handleCancel = () => {
    this.setState({visible: false});
  };
  handleUpload = (newFirmware) => {
    this.props.onUpload(newFirmware)
    this.setState({visible: false});
  };
  saveFormRef = (form) => {
    this.form = form;
  };
  render() {
    const {hub, system, token} = this.props
    return (<span>
      <Button type="primary" ghost="ghost" size="small" icon="upload" onClick={this.showModal}>Firmware</Button>
      <SystemHubCheckFirmwareModalForm title="Upload firmware" hub={hub} system={system} token={token} ref={this.saveFormRef} visible={this.state.visible} onCancel={this.handleCancel} onSubmit={this.handleUpload}/>
    </span>);
  }
}

export default SystemHubButtonUploadFirmware;



// WEBPACK FOOTER //
// ./src/components/SystemHubButtonUploadFirmware.js